import { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { IPool } from '@/helpers/jackpot';
import { usePoolData } from '@/modules/jackpot/hooks';
import { AnimatedCrystal } from '../../../AnimatedCrystal';
import { ScPool, ScPoolInfo, ScPools } from './styled';

interface IPoolsProps {
  pools: IPool[];
}

export const Pools: FC<IPoolsProps> = memo(({ pools }) => (
  <ScPools>
    {pools.map((pool) => (
      <Pool key={pool.id} {...pool} />
    ))}
  </ScPools>
));

export const Pool: FC<IPool> = memo((pool) => {
  const { t } = useTranslation(['common', 'jackpot']);
  const { formattedPrize, formattedHitRange, poolStatus } = usePoolData(pool);

  return (
    <ScPool className={poolStatus || undefined}>
      <div className="inner">
        <ScPoolInfo>
          <div className="title">{pool.title}</div>
          <div className="prize">{formattedPrize}</div>
        </ScPoolInfo>
        <div className="icon">
          <AnimatedCrystal size={72} type={pool.type} />
        </div>
      </div>
      <div className="bottom">
        {poolStatus && (
          <div className="badge">
            {t(`common:jackpot.status.${poolStatus}`)}
          </div>
        )}
        <div className="hit-range">
          {t('jackpot:hitRange', { range: formattedHitRange })}
        </div>
      </div>
    </ScPool>
  );
});
